import React from "react";
import "./PageNotFound.css";
import Error from '../../Assets/404_Error.png'

const PageNotFound = () => {
  return (
    <div className="main-not-found-container">
      <div className="not-found-content">
      
        <div className="not-found-body">
          <img src={Error} alt="404" className="not-found-illustration" />
          <p className="not-found-text">
            It seems like the page you're looking for has moved, or doesn’t exist.
            <br />
            Don’t worry! Let’s get you back on track.
          </p>
        </div>
        <div className="not-found-actions">
          <a href="/" className="cta-button">Go Back to Home</a>
          <a href="/courses" className="cta-button secondary">Browse Courses</a>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
